import { TextBlock } from '../../TextBlock';

export type InstructionsProps = {
  type: 'instructions';
  title: string;
  instructions: string[];
};

export const Instructions = ({ title, instructions }: InstructionsProps) => {
  return (
    <div>
      <h6 className="global-t6-semibold">{title}</h6>
      <ol className="mb-0 mt-4 list-none space-y-2 pl-0">
        {instructions?.map?.((instruction, index) => (
          <li key={index} className="mb-2 flex body-14-semibold">
            <strong className="mr-2">{index + 1}</strong>
            <TextBlock text={instruction} className="flex-1" />
          </li>
        ))}
      </ol>
    </div>
  );
};
